import { RoleId } from '@common/constants';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useIdentityStore from '@/stores/useIdentityStore';
import useQuoteIntakeSetupStore from '@/stores/useQuoteIntakeSetupStore';
import IntakeDesign from './IntakeDesignConfiguration/IntakeDesign';
import PreIntake from './IntakeDesignConfiguration/PreIntake';
import IntakeEmailReminder from './IntakeEmailReminder/IntakeEmailReminder';
import PricingDetails from './PricingDetails/PricingDetails';
import QuoteDesign from './QuoteDesign';
import QuoteEmailReminderTemplate from './QuoteEmailConfiguration/QuoteEmailReminderTemplate';
import QuoteEmailTemplate from './QuoteEmailConfiguration/QuoteEmailTemplate';
import TransactionType from './TransactionType';

export default function QuoteIntakeSetup() {
    const [formData, currentStep, setFormData] = useQuoteIntakeSetupStore((state) => [
        state.formData,
        state.currentStep,
        state.setFormData,
    ]);
    const user = useIdentityStore((state) => state.user);
    const { quoteIntakeId } = useParams();

    useEffect(() => {
        // set assigned lawyer as the logged in user if logged in user is a lawyer
        const lawyerUser = user?.roles?.find((role) => role.roleId === RoleId.LAWYER);
        if (!quoteIntakeId && lawyerUser) {
            setFormData('step0', { ...formData.step0, assignedLawyer: user?.userId });
        }
    }, [quoteIntakeId]);

    return (
        <>
            {currentStep === 0 && <TransactionType />}
            {currentStep === 1 && <QuoteDesign />}
            {currentStep === 2 &&
                (formData.step2.isScreenTwo ? (
                    <QuoteEmailReminderTemplate />
                ) : (
                    <QuoteEmailTemplate />
                ))}
            {currentStep === 3 && <PricingDetails />}
            {currentStep === 4 && (formData.step4.isScreenTwo ? <IntakeDesign /> : <PreIntake />)}
            {currentStep === 5 && <IntakeEmailReminder />}
        </>
    );
}
